import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import './Auth.css';

export default function AuthLayout({ children, variant = 'form' }) {
  const { preference } = useTheme();
  const isLight = preference === 'light';
  return (
    <div className={`auth-page auth-page--${variant}`}>
      <header className="auth-brand">
        <img src={`${process.env.PUBLIC_URL || ''}/${isLight ? 'Vylo - Light BG.svg' : 'Vylo - Dark BG.svg'}`} alt="Vylo" />
      </header>
      <main className="auth-stage">
        <div className="auth-column">{children}</div>
      </main>
    </div>
  );
}
